const AnalyticsSecrets = {
    PROD: {
        MIXPANEL_TOKEN: '44a7d57be67cbca146cd0c2e49e05c6e',
    },
};

export default AnalyticsSecrets;
